import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {DialogComponent} from "@syncfusion/ej2-angular-popups";

/**
 * This component is only used on the Knockout side to wrap a DOM element
 * that has been built using a Knockout template. It replaces the Foundation
 * reveal component.
 *
 * Some methods are defined on the native element, so they can be called
 * naturally on the Knockout side.
 */
@Component({
  selector: 'sb-modal-wrapper',
  templateUrl: './modal-wrapper.component.html',
  styleUrls: ['./modal-wrapper.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ModalWrapperComponent implements OnInit {

  @ViewChild('modal')
  modal: DialogComponent;

  constructor(elementRef: ElementRef) {
    (elementRef.nativeElement as any).setContent = this.setContent.bind(this);
    (elementRef.nativeElement as any).setButtons = this.setButtons.bind(this);
    (elementRef.nativeElement as any).destroy = this.destroy.bind(this);
    (elementRef.nativeElement as any).show = this.show.bind(this);
    (elementRef.nativeElement as any).hide = this.hide.bind(this);
    (elementRef.nativeElement as any).getModal = this.getModal.bind(this);
  }

  destroy() {
    this.modal.destroy();
  }

  hide() {
    this.modal.hide();
  }

  show(isFullScreen?: boolean) {
    this.modal.show(isFullScreen);
  }

  getModal(): any {
    return this.modal;
  }

  setContent(element: any) {
    (this.modal as any).contentEle.appendChild(element);
  }

  setButtons(buttons: any[]) {
    this.modal.buttons = buttons;
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }
}
